









import Vue from "vue";
import Component from "vue-class-component";
import MoodboardImage from "./MoodboardImage.vue";

@Component({
  components: { MoodboardImage },
})
export default class Moodboard extends Vue {
  private moodboardImages: string[] = [
    "fastrope",
    "allied_tank",
    "clone_troopers",
    "fireteam_sunrise",
    "vietnam_sniper",
    "weapons_team",
  ];
}
